import React, { Component } from 'react'

import { CardWrapper, Title, Tools, PhotoWrapper, Description } from './styles'
import PhotoGallery from '../PhotoGallery'
import ReactHtmlParser from 'react-html-parser';

class Card extends Component {
  render() {
    return (
      <CardWrapper>
        <Title>{this.props.title}</Title>
        {this.props.tools && <Tools>{this.props.tools}</Tools>}
        <PhotoWrapper>
          {this.props.photos && <PhotoGallery photos={this.props.photos} />}
        </PhotoWrapper>
        <Description>{ReactHtmlParser(this.props.description)}</Description>
      </CardWrapper>
    )
  }
}

export default Card



// WEBPACK FOOTER //
// ./src/containers/CS/components/ProjectsCarousel/components/Card/index.js